import { ReportTypeLevelKey } from '../types'
import { ReportConfigurationType } from '../enums/report-configuration-type'
import { ReportConfigurationLevel } from '../enums/report-configuration-level'
import { ReportConfigurationBreakdown } from '../enums/report-configuration-breakdown'

export const COLUMN_TABLE_ORDER: Partial<Record<ReportTypeLevelKey, string[]>> = {
    DELIVERY_ORGANIZATION: [
        'DATE',
        'DOMAIN.ID',
        'DOMAIN.DISPLAY_NAME',
        'NOTIFICATION_GROUP.ID',
        'CHANNEL',
        'PLACEMENT',
        'NOTIFICATIONS_SENT',
        'IMPRESSIONS',
        'CLICKS',
        'CTR_DECIMAL',
        'CLICKS_PER_SEND',
    ],
    DELIVERY_DOMAIN: [
        'DATE',
        'DOMAIN.ID',
        'DOMAIN.DISPLAY_NAME',
        'DOMAIN.NAME',
        'CHANNEL',
        'BUTTON.ID',
        'BUTTON.TYPE',
        'BUTTON.LABEL',
        'BUTTON.LANDING_URL',
        'OPERATING_SYSTEM',
        'PLACEMENT',
        'BROWSER',
        'NOTIFICATION_GROUP.ID',
        'NOTIFICATIONS_SENT',
        'DELIVERIES',
        'DELIVERY_RATE_DECIMAL',
        'IMPRESSIONS',
        'CLICKS',
        'CTR_DECIMAL',
        'CLICKS_PER_SEND',
        'PURCHASES',
        'PURCHASE_AMOUNT',
    ],
    DELIVERY_NOTIFICATION: [
        'DATE',
        'DOMAIN.ID',
        'DOMAIN.DISPLAY_NAME',
        'NOTIFICATION_GROUP.ID',
        'NOTIFICATION_GROUP_IS_MULTI_DOMAIN',
        'NOTIFICATION.ID',
        'NOTIFICATION.SCHEDULE_ID',
        'CHANNEL',
        'OPERATING_SYSTEM',
        'PLACEMENT',
        'BROWSER',
        'NOTIFICATION.TITLE',
        'STEP.TEMPLATE_TITLE',
        'NOTIFICATION.BODY',
        'STEP.TEMPLATE_BODY',
        'NOTIFICATION_SOURCE',
        'NOTIFICATION.SCHEDULED_TIME',
        'NOTIFICATION.SCHEDULED_TIME_ZONE',
        'NOTIFICATION.DELIVERY_STRATEGY',
        'NOTIFICATION.REPLACEMENT_BEHAVIOR',
        'NOTIFICATION.TARGETED_CHANNELS',
        'NOTIFICATION.AUDIENCES',
        'NOTIFICATION.ICON_URL',
        'NOTIFICATION.BADGE_URL',
        'NOTIFICATION.IMAGE_URL',
        'NOTIFICATION.KEYWORDS',
        'NOTIFICATION.LANDING_URL',
        'NOTIFICATION.LIFESPAN',
        'NOTIFICATION.CREATED_BY',
        'BUTTON.ID',
        'BUTTON.TYPE',
        'BUTTON.LABEL',
        'BUTTON.LANDING_URL',
        'TEST.ID',
        'TEST.NAME',
        'TEST.CREATED_BY',
        'NOTIFICATION.WEIGHT',
        'CAMPAIGN.ID',
        'CAMPAIGN.NAME',
        'STEP.ID',
        'STEP.NAME',
        'NOTIFICATION.CONTENT_SOURCE',
        'NOTIFICATION.AI_CONTENT_TONE',
        'NOTIFICATIONS_SENT',
        'DELIVERIES',
        'DELIVERY_RATE_DECIMAL',
        'IMPRESSIONS',
        'CLICKS',
        'CTR_DECIMAL',
        'PURCHASES',
        'PURCHASE_AMOUNT',
        'PURCHASE_RATE_DECIMAL',
    ],
    DELIVERY_TEST: [
        'DATE',
        'OPERATING_SYSTEM',
        'PLACEMENT',
        'BROWSER',
        'TEST.ID',
        'TEST.NAME',
        'CHANNEL',
        'TEST.CREATED_BY',
        'DELIVERIES',
        'DELIVERY_RATE_DECIMAL',
        'IMPRESSIONS',
        'CLICKS',
        'CTR_DECIMAL',
    ],
    DELIVERY_CAMPAIGN: [
        'DATE',
        'CAMPAIGN.ID',
        'CAMPAIGN.NAME',
        'CAMPAIGN.STATUS',
        'CAMPAIGN.DATE_START',
        'CAMPAIGN.DATE_END',
        'SPLIT_TEST.NAME',
        'VARIANT.NAME',
        'VARIANT.PERCENTAGE',
        'STEP.NAME',
        'STEP.TYPE',
        'ENTRANCES',
        'EXITS',
        'IMPRESSIONS',
        'CLICKS',
        'CTR_DECIMAL',
        'CPS',
        'DELIVERIES',
        'DELIVERY_RATE_DECIMAL',
        'PURCHASES',
        'PURCHASE_AMOUNT',
    ],
    DELIVERY_SEGMENT: [
        'DATE',
        'SEGMENT.ID',
        'SEGMENT.NAME',
        'CHANNEL',
        'PLACEMENT',
        'DELIVERIES',
        'IMPRESSIONS',
        'DELIVERY_RATE_DECIMAL',
        'CLICKS',
        'CTR_DECIMAL',
        'CLICKS_PER_SEND',
        'NOTIFICATIONS_SENT',
        'SIZE',
        'SEGMENT_LAST_TARGETED_DATE_TZ',
    ],
    DELIVERY_KEYWORD: [
        'DATE',
        'KEYWORD',
        'CHANNEL',
        'DELIVERIES',
        'IMPRESSIONS',
        'DELIVERY_RATE_DECIMAL',
        'CLICKS',
        'CTR_DECIMAL',
        'NOTIFICATIONS_SENT',
    ],

    SUBSCRIBER_ORGANIZATION: [
        'DATE',
        'DOMAIN.ID',
        'DOMAIN.DISPLAY_NAME',
        'CHANNEL',
        'PLACEMENT',
        'PERMISSIONS_SHOWN',
        'PERMISSIONS_DISMISSED',
        'PERMISSIONS_DENIED',
        'SUBSCRIPTIONS',
        'SUBSCRIPTION_RATE_DECIMAL',
        'PROMPTS_SHOWN',
    ],
    SUBSCRIBER_DOMAIN: [
        'DATE',
        'DOMAIN.ID',
        'DOMAIN.NAME',
        'CHANNEL',
        'OPERATING_SYSTEM',
        'PLACEMENT',
        'BROWSER',
        'PERMISSIONS_SHOWN',
        'PERMISSIONS_DISMISSED',
        'PERMISSIONS_DENIED',
        'SUBSCRIPTIONS',
        'SUBSCRIPTION_RATE_DECIMAL',
        'PROMPTS_SHOWN',
        'PROMPTS_DISMISSED',
        'PROMPTS_SHOWN_NON_UNIQUE',
        'PROMPTS_DISMISSED_NON_UNIQUE',
        'PROMPTS_ACCEPTED',
        'PROMPT_ACCEPT_RATE_DECIMAL',
    ],
    SUBSCRIBER_PROMPT: [
        'DATE',
        'PROMPT.ID',
        'PROMPT.NAME',
        'CHANNEL',
        'OPERATING_SYSTEM',
        'PLACEMENT',
        'BROWSER',
        'PROMPT.STYLE',
        'PROMPT.PRIORITY',
        'GROUP.ID',
        'GROUP.NAME',
        'TEST.ID',
        'TEST.NAME',
        'PROMPT.VISITOR_CONDITIONS',
        'PERMISSIONS_SHOWN',
        'PERMISSIONS_DISMISSED',
        'PERMISSIONS_DENIED',
        'SUBSCRIPTIONS',
        'SUBSCRIPTION_RATE_DECIMAL',
        'PROMPTS_SHOWN',
        'PROMPTS_DISMISSED',
        'PROMPTS_SHOWN_NON_UNIQUE',
        'PROMPTS_DISMISSED_NON_UNIQUE',
        'PROMPTS_ACCEPTED',
        'PROMPT_ACCEPT_RATE_DECIMAL',
    ],
    SUBSCRIBER_TEST: [
        'DATE',
        'OPERATING_SYSTEM',
        'PLACEMENT',
        'BROWSER',
        'TEST.ID',
        'TEST.NAME',
        'PERMISSIONS_SHOWN',
        'PERMISSIONS_DISMISSED',
        'PERMISSIONS_DENIED',
        'SUBSCRIPTIONS',
        'SUBSCRIPTION_RATE_DECIMAL',
        'PROMPTS_SHOWN',
        'PROMPTS_DISMISSED',
        'PROMPTS_SHOWN_NON_UNIQUE',
        'PROMPTS_DISMISSED_NON_UNIQUE',
        'PROMPTS_ACCEPTED',
        'PROMPT_ACCEPT_RATE_DECIMAL',
    ],
    MONTHLY_UNIQUES_DOMAIN: [
        'DATE',
        'DOMAIN.ID',
        'PLACEMENT',
        'CHANNEL',
        'IMPRESSIONS',
        'CLICKS',
        'CTR_DECIMAL',
        'PERMISSIONS_SHOWN',
        'SUBSCRIPTIONS',
        'SUBSCRIPTION_RATE_DECIMAL',
    ],
    PUB_NETWORK_DOMAIN: ['DATE', 'IMPRESSIONS', 'PAID_CLICKS', 'PAID_CTR_DECIMAL', 'REVENUE'],
    APP_MESSAGE_DOMAIN: ['DATE', 'PLACEMENT', 'CHANNEL', 'IMPRESSIONS', 'CLICKS', 'CTR_DECIMAL'],
    APP_MESSAGE_APP_MESSAGE: [
        'DATE',
        'PLACEMENT',
        'CHANNEL',
        'APP_MESSAGE.ID',
        'APP_MESSAGE.NAME',
        'APP_MESSAGE.STYLE',
        'APP_MESSAGE.RUN_DATE_START',
        'APP_MESSAGE.RUN_DATE_END',
        'APP_MESSAGE.RUN_DATE_TIME_ZONE',
        'APP_MESSAGE.AUDIENCES',
        'IMPRESSIONS',
        'CLICKS',
        'CTR_DECIMAL',
    ],
    LIVE_ACTIVITY_DOMAIN: ['DATE', 'STARTS', 'UPDATES_SENT'],
    LIVE_ACTIVITY_ACTIVITY: ['DATE', 'ACTIVITY.ID', 'STARTS', 'UPDATES_SENT'],
}

export function isDeliveryTestNotificationAlias(
    type: ReportConfigurationType,
    level: ReportConfigurationLevel,
    breakdown: string = ReportConfigurationBreakdown.NONE,
): boolean {
    return (
        type === ReportConfigurationType.DELIVERY &&
        level === ReportConfigurationLevel.TEST &&
        breakdown === ReportConfigurationBreakdown.NOTIFICATION
    )
}

export function resolveEffectiveLevelForCatalog(
    type: ReportConfigurationType,
    level: ReportConfigurationLevel,
    breakdown: string = ReportConfigurationBreakdown.NONE,
): ReportConfigurationLevel {
    return isDeliveryTestNotificationAlias(type, level, breakdown) ? ReportConfigurationLevel.NOTIFICATION : level
}

export function resolveColumnTableOrder(
    type: ReportConfigurationType,
    level: ReportConfigurationLevel,
    breakdown: string = ReportConfigurationBreakdown.NONE,
): string[] {
    const effectiveLevel = resolveEffectiveLevelForCatalog(type, level, breakdown)
    const baseOrder = [...(COLUMN_TABLE_ORDER[`${type}_${effectiveLevel}`] || [])]

    if (!isDeliveryTestNotificationAlias(type, level, breakdown)) {
        return baseOrder
    }

    // Keep notification-level order in alias mode, but pin test identity first.
    const pinnedAfterDate = ['TEST.ID', 'TEST.NAME']
    const withoutPinned = baseOrder.filter((col) => !pinnedAfterDate.includes(col))

    if (!withoutPinned.includes('DATE')) {
        return [...pinnedAfterDate, ...withoutPinned]
    }

    return ['DATE', ...pinnedAfterDate, ...withoutPinned.filter((col) => col !== 'DATE')]
}
